/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ex_NoteInputs */

const en_to_typescript_ex_note = /** @type {(inputs: To_Typescript_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The root interface is always named RootObject, and when the input is an array it describes the shape of one element rather than the array itself. Because nickname is absent from the second record, it is optional. Had you pasted only the first record, it would have been required.`)
};

const ko_to_typescript_ex_note = /** @type {(inputs: To_Typescript_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`루트 인터페이스는 항상 RootObject로 이름이 붙으며, 입력이 배열이면 배열 자체가 아니라 요소 하나의 형태를 기술합니다. nickname이 두 번째 레코드에 없으므로 선택적입니다. 첫 번째 레코드만 붙여넣었다면 필수가 되었을 것입니다.`)
};

const ja_to_typescript_ex_note = /** @type {(inputs: To_Typescript_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ルートインターフェースは常に RootObject と名付けられ、入力が配列のときは配列自体ではなく要素 1 つの形を記述します。nickname が 2 件目のレコードにないので任意になっています。1 件目だけを貼り付けていたら必須になっていました。`)
};

/**
* | output |
* | --- |
* | "The root interface is always named RootObject, and when the input is an array it describes the shape of one element rather than the array itself. Because nic..." |
*
* @param {To_Typescript_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ex_note = /** @type {((inputs?: To_Typescript_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ex_note(inputs)
	if (locale === "ko") return ko_to_typescript_ex_note(inputs)
	return ja_to_typescript_ex_note(inputs)
});